export const rbbPost = async (url = '', data = {}) => {
  return await fetch(url, {
    method: 'POST',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    redirect: 'follow',
    body: JSON.stringify(data)
  });
};